export const reportsEndpoints = {
    getAll: () => ({
      path: '/Admin/Report/GetAll',
      method: 'GET' as const,
    }),
    resolveReports: {
      path: '/Admin/Report/BulkChangeToResolve',
      method: 'PATCH' as const,
    }
  } as const;